import { OffersService } from './offers';
import { TariffType } from '../../schema';

export async function findAll (): Promise<any> {
    return OffersService.findAll();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/offers/offers.find-all.ts